export enum CondominiumPages {
  BasicData = 'basic-data',
  Sections = 'sections',
  Units = 'units',
  CommonAreas = 'common-areas',
}

export default CondominiumPages;
